export const AltValChange = () => {
    return (
        <div className="container">
            <h2>変数軽減</h2>
           <p>変数が変動する際軽減します</p>
           <h3>使い方</h3>
           <p><img src={`${process.env.PUBLIC_URL}/alt_val_change_example.png`}></img></p>
           <p>図では自分ライフ(①)が１０００(②③)までダメージを軽減することを表しています</p>
        </div>
    )
}
